export { default } from "ember-stereo/stereo-connections/base";
